import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";
import { ApiResponse } from "@/api/types";
import dayjs from "dayjs";

const mutations: ExMutationTree<State, Mutations> = {
  getNotificationsSuccess(state, payload) {
    const newNotifications = payload.notifications || [];
    const distinctNotifications = state.notifications;
    // NOTE 過去に取得した通知に重複IDが存在すれば新しいNotificationに置き換える
    newNotifications.forEach(notification => {
      const duplicatedIndex = distinctNotifications.findIndex(
        e => e.id === notification.id
      );
      if (duplicatedIndex !== -1)
        distinctNotifications[duplicatedIndex] = notification;
      else distinctNotifications.push(notification);
    });
    state.notifications = distinctNotifications;
  },
  getNewArrivalNotificationsSuccess(state, payload) {
    state.newArrivalNotifications = payload.newArrivalNotifications;
  },
  resetNotifications(state) {
    state.notifications = [];
  },
  readNotificationSuccess(state, payload) {
    const callback = (notification: ApiResponse.Notification) =>
      notification.id === payload.notificationId
        ? { ...notification, read_at: dayjs().format() }
        : notification;
    state.newArrivalNotifications = state.newArrivalNotifications.map(callback);
    state.notifications = state.notifications.map(callback);
  },
  readNotificationFailed(state, payload) {
    const callback = (notification: ApiResponse.Notification) =>
      notification.id === payload.notificationId
        ? { ...notification, read_at: payload.preReadAt }
        : notification;
    state.newArrivalNotifications = state.newArrivalNotifications.map(callback);
    state.notifications = state.notifications.map(callback);
  },
  setNewArrivalNotificationSnapshotForHeaderBadge(state, payload) {
    state.newArrivalNotificationSnapshotForHeaderBadge =
      payload || state.newArrivalNotifications[0];
  }
  // setIsHeaderNotificationBadgeVisible(state, payload) {
  //   state.isHeaderNotificationBadgeVisible =
  //     payload.isHeaderNotificationBadgeVisible;
  // }
};

export default mutations;
